<template>

  <heads>
    <div class="grid grid-cols-2 gap-4">
      <div
        class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg"
      >
        <p class="text-lg font-medium mb-4">List Designation</p>
        <breeze-table
          :fields="fields"
          :items="designations"
          :canView="hasRole('View Designation')"
        >
          <template #action="data">
            <breeze-button v-if="hasRole('Edit Designation')"  @click.prevent="designation=data.item">Edit</breeze-button>
          </template>
        </breeze-table>
      </div>
      <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing" />
                <div :class="{ 'opacity-50': form.processing, 'opacity-100': !form.processing }">
                    <p class="text-lg font-medium mb-4">{{ designation?.id?'Update':'Add'}} Designation</p>
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Name'" />
                                <breeze-input required v-model="form.name" class="w-full" />
                                <breeze-input-error :message="form.errors ? form.errors.name : ''" />
                            </div>
                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <breeze-button v-if="designation?.id" type="button"  class="bg-red-500 ml-4 hover:bg-red-400"  @click="designation=[]">Cancel</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">
                            designation Added
                        </span>
                        <exception />
                    </form>
                </div>
      </div>
    </div>
  </heads>
</template>

<script setup>
import Heads from "@/Pages/Heads/Heads";
import BreezeInput from "@/Components/Input";
import BreezeLabel from "@/Components/Label";
import ButtonLink from "@/Components/ButtonLink";
import CardHeader from "@/Components/CardHeader";
import { useForm } from "@inertiajs/inertia-vue3";
import BreezeInputError from "@/Components/InputError";
import BreezeButton from "@/Components/Button";
import BreezeCheckbox from "@/Components/Checkbox";
import Loading from "@/Components/Loading";
import Exception from "@/Components/Exception";
import BreezeTable from "@/Components/Table";
import { ref, watch } from "vue";
import {hasRole} from "../../../../Utils/checkPermission";

defineProps({
  designations: Object
});

const form = useForm({
  name: ""
});
const fields = [
  { key: "name", label: "Name" },
  { key: "action", label: "Action" }
];

const designation=ref([]);

watch(designation,(n,o)=>{
  form.name=designation.value?.name
})

function submitForm() {
    if(designation.value?.id){
        form.post(route("heads.designation.update",designation.value.id), {
            preserveScroll: true,
            onSuccess: () => {
            location.reload();
            designation.value=[];
            this.form.reset();
            }
        });
    }else{
        form.post(route("heads.designation.store"), {
            preserveScroll: true,
            onSuccess: () => {
            location.reload();
            this.form.reset();
            }
        });
    }

}
</script>
